import Logger from "../../../../../utils/Logger";

// Interface for the response option of each question
export interface ResponseOption {
  answer_id: string;
  question_id: string;
  answer: string;
  answered?: boolean;
  answer_media: boolean;
  answer_media_urls: string | null;
}

// Interface for a single question
export interface Question {
  question_id: string;
  question: string;
  difficulty_level: string;
  question_type: string;
  question_media: boolean;
  question_media_urls: string | null;
  number_of_options: number;
  response_option_1: ResponseOption | null;
  response_option_2: ResponseOption | null;
  response_option_3: ResponseOption | null;
  response_option_4: ResponseOption | null;
  question_audio: string | null;
  answer_selected: string | null;
  time_spend: number | null;
  flag_selected: boolean;
}

// Interface for each dimension (group of questions)
export interface Dimension {
  dimension_id: string;
  question: Question;
  seq_number: number;
  given_status: boolean;
}

// Main interface for the quiz data
export interface QuizData {
  no_of_questions: number;
  assessment_id?: String;
  questions: Dimension[];
  // Handling error scenerios
  detail?: string;
  error?: string;
}

// Example usage with the provided data structure
export const quizData: QuizData = {
  no_of_questions: 3,
  questions: [
    {
      dimension_id: "791c76a7-dac4-4a74-9d25-51f5af03fa69",
      question: {
        question_id: "2fa1679b-6d8e-4097-a793-dc7d7f9237c2",
        question: "question 1 here",
        difficulty_level: "Easy",
        question_type: "Pop Quiz",
        question_media: false,
        question_media_urls: null,
        number_of_options: 4,
        response_option_1: {
          answer_id: "a38d2aad-f042-4dca-9cbe-c9350cfaef58",
          question_id: "2fa1679b-6d8e-4097-a793-dc7d7f9237c2",
          answer: "option 1 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_2: {
          answer_id: "7f4487e8-b908-4165-b074-5c6c3253f388",
          question_id: "2fa1679b-6d8e-4097-a793-dc7d7f9237c2",
          answer: "option 2 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_3: {
          answer_id: "9f68a2c5-c2c6-4e25-b599-bc8980b21e3e",
          question_id: "2fa1679b-6d8e-4097-a793-dc7d7f9237c2",
          answer: "correct option 3 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_4: {
          answer_id: "5a97b4f1-f365-4b80-86d9-c79095a9f19a",
          question_id: "2fa1679b-6d8e-4097-a793-dc7d7f9237c2",
          answer: "option 4 here",
          answer_media: false,
          answer_media_urls: null,
        },
        question_audio: null,
        answer_selected: null,
        time_spend: null,
        flag_selected: false,
      },
      seq_number: 1,
      given_status: false,
    },
    {
      dimension_id: "791c76a7-dac4-4a74-9d25-51f5af03fa69",
      question: {
        question_id: "67f46758-e3a9-4796-93d8-699d7bdd7592",
        question: "question 2 here",
        difficulty_level: "Easy",
        question_type: "Pop Quiz",
        question_media: false,
        question_media_urls: null,
        number_of_options: 4,
        response_option_1: {
          answer_id: "782cb74c-259b-4dd2-9a5e-d445791c02a1",
          question_id: "67f46758-e3a9-4796-93d8-699d7bdd7592",
          answer: "option 1 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_2: {
          answer_id: "8bc0d8f7-a315-469a-b365-6658339abc61",
          question_id: "67f46758-e3a9-4796-93d8-699d7bdd7592",
          answer: "option 2 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_3: {
          answer_id: "a7a82e6b-9cac-4c45-846b-f9cef8021f1f",
          question_id: "67f46758-e3a9-4796-93d8-699d7bdd7592",
          answer: "correct option 3 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_4: {
          answer_id: "7727f5ae-8969-4d72-98dc-6663b5992847",
          question_id: "67f46758-e3a9-4796-93d8-699d7bdd7592",
          answer: "option 4 here",
          answer_media: false,
          answer_media_urls: null,
        },
        question_audio: null,
        answer_selected: null,
        time_spend: null,
        flag_selected: false,
      },
      seq_number: 2,
      given_status: false,
    },
    {
      dimension_id: "791c76a7-dac4-4a74-9d25-51f5af03fa69",
      question: {
        question_id: "6adcb39a-5f3b-4c62-9d61-fbc5dbef8601",
        question: "question 4 here",
        difficulty_level: "Easy",
        question_type: "Pop Quiz",
        question_media: false,
        question_media_urls: null,
        number_of_options: 4,
        response_option_1: {
          answer_id: "cff59048-0cd2-4c0e-821b-d2909993bdf6",
          question_id: "6adcb39a-5f3b-4c62-9d61-fbc5dbef8601",
          answer: "option 1 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_2: {
          answer_id: "371d2df1-f50a-4105-be83-eb1af3cc4122",
          question_id: "6adcb39a-5f3b-4c62-9d61-fbc5dbef8601",
          answer: "option 2 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_3: {
          answer_id: "30dbd7f7-866d-4db0-8144-fd096bac43f7",
          question_id: "6adcb39a-5f3b-4c62-9d61-fbc5dbef8601",
          answer: "correct option 3 here",
          answer_media: false,
          answer_media_urls: null,
        },
        response_option_4: {
          answer_id: "168323e8-cb3a-4db4-a29d-af2bb02bc9ba",
          question_id: "6adcb39a-5f3b-4c62-9d61-fbc5dbef8601",
          answer: "option 4 here",
          answer_media: false,
          answer_media_urls: null,
        },
        question_audio: null,
        answer_selected: null,
        time_spend: null,
        flag_selected: false,
      },
      seq_number: 3,
      given_status: false,
    },
  ],
};

// Interface for the entire request payload
export interface QuizRequest {
  total_questions: number;
  questions: Question[];
}

// Function to dynamically generate the payload with "answered" field set based on selection
// ⚡ Final Working Function
export function createQuizRequest(
  questionsData: Dimension[], // 👈 fixed type
  selectedAnswers: string[]
): QuizRequest {
  const totalQuestions = questionsData.length;

  const questions: Question[] = questionsData.map((dimension, index) => {
    const question = dimension.question;
    const selectedAnswerId = selectedAnswers[index];
    Logger.info("Selected answer id ", selectedAnswerId);

    const prepareOption = (
      option: ResponseOption | null
    ): ResponseOption | null => {
      if (!option) return null;
      return {
        ...option,
        answered: option.answer_id === selectedAnswerId, // ✅ set 'answered' here
      };
    };

    return {
      ...question,
      response_option_1: prepareOption(question.response_option_1),
      response_option_2: prepareOption(question.response_option_2),
      response_option_3: prepareOption(question.response_option_3),
      response_option_4: prepareOption(question.response_option_4),
      answer_selected: selectedAnswerId || null,
      time_spend: question.time_spend ?? null,
      flag_selected: question.flag_selected ?? false,
    };
  });

  return {
    total_questions: totalQuestions,
    questions: questions,
  };
}
